import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import useReportQueryParams from '../../../../hooks/use-report-query-params';
import ProgressForCharactersChartView from './ProgressForCharactersChartView';
import ProgressForCharactersTableView from './ProgressForCharactersTableView';
import { ModuleType, ReportView } from '../../../../types';

const StudentProgressCards: React.FC = () => {
  const [{ viewAs }] = useReportQueryParams();
  const { t } = useTranslation('Reports');

  const chartView = (
    <>
      <ProgressForCharactersChartView module={ModuleType.CAPITALS} />
      <ProgressForCharactersChartView module={ModuleType.LOWERCASE} />
      <ProgressForCharactersChartView module={ModuleType.NUMBERS} />
    </>
  );

  const tableView = (
    <article>
      <Grid container wrap="wrap" spacing={2}>
        <Grid item xs={12} lg={6}>
          <ProgressForCharactersTableView module={ModuleType.CAPITALS} />
        </Grid>
        <Grid item xs={12} lg={6}>
          <ProgressForCharactersTableView module={ModuleType.LOWERCASE} />
        </Grid>
        <Grid item xs={12}>
          <ProgressForCharactersTableView module={ModuleType.NUMBERS} />
        </Grid>
      </Grid>
    </article>
  );

  const REPORT_VIEW_MAP: { [key in ReportView]?: any } = {
    [ReportView.CHART]: chartView,
    [ReportView.TABLE]: tableView
  };

  return (
    <section>
      <Typography variant="h3">{t('Progress')}</Typography>
      {REPORT_VIEW_MAP[viewAs]}
    </section>
  );
};

export default React.memo(StudentProgressCards);
